/**
 * Performance Constants - Web vitals thresholds and performance metrics
 */

// Core Web Vitals thresholds (milliseconds)
export const CORE_WEB_VITALS = {
  // Largest Contentful Paint (LCP)
  LCP: {
    GOOD: 2500,
    POOR: 4000,
  },
  
  // First Input Delay (FID) 
  FID: {
    GOOD: 100,
    POOR: 300,
  },
  
  // Cumulative Layout Shift (CLS)
  CLS: {
    GOOD: 0.1,
    POOR: 0.25,
  },
  
  // Additional timing metrics
  LOAD_TIME: {
    GOOD: 3000,
    POOR: 5000,
  },
} as const;

// Performance scoring thresholds
export const PERFORMANCE_SCORE = {
  EXCELLENT_MIN: 90,
  GOOD_MIN: 70,
  BASE_SCORE: 100,
} as const;

// Performance penalties (score deductions)
export const PERFORMANCE_PENALTIES = {
  LCP_POOR: 30,
  LCP_FAIR: 15,
  FID_POOR: 25,
  FID_FAIR: 10,
  CLS_POOR: 20,
  CLS_FAIR: 10,
  MEMORY_HIGH: 15,
  MEMORY_MEDIUM: 8,
  LOAD_TIME_POOR: 20,
  LOAD_TIME_FAIR: 10,
  LOW_BATTERY: 5,
} as const;

// Memory usage thresholds (percentages)
export const MEMORY_THRESHOLDS = {
  HIGH: 80,
  MEDIUM: 60,
  WARNING: 70,
} as const;

// Battery level thresholds (percentages)
export const BATTERY_THRESHOLDS = {
  LOW: 20,
} as const;

// Balance column height difference threshold
export const LAYOUT_THRESHOLDS = {
  COLUMN_HEIGHT_DIFFERENCE: 96, // pixels
  BALANCE_STABLE_COUNT: 2,
} as const;

// Intersection observer thresholds
export const INTERSECTION_THRESHOLDS = {
  DEFAULT: 0.1,
  LAZY_LOADING: 0.1,
  STRICT: 0.2,
  MOBILE_SCROLL: 0.3,
} as const;